import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import ComponentSize from '../../../ComponentSize'
import AuctionCard from './AuctionCard'

interface AuctionCardProps {
  page?: string
  quadkey: Quadkey
  size?: ComponentSize
}

const InView: React.FC<AuctionCardProps> = (props) => {
  const { quadkey, size, page } = props

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  return <div ref={ref}>{inView ? <AuctionCard page={page} quadkey={quadkey} size={size} /> : null}</div>
}

export default InView
